import { Avatar, Box, Button, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetParentGymByIdQuery } from 'src/api/parentGymApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type ViewParentGymDetailsModalProps = {
  id: number
  open: boolean
  onClose: () => void
}
const ViewParentGymDetailsModal = ({ id, open, onClose }: ViewParentGymDetailsModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, isFetching, refetch } = useGetParentGymByIdQuery(id)

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            {!!data?.picture && (
              <Box textAlign='center'>
                <img
                  src={data?.picture}
                  style={{
                    width: '100%',
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Gym Name:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.name} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Branchs :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.branches_count} </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewParentGymDetailsModal
